import {NgModule} from '@angular/core';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HomePage} from './home.page';

import {HomePageRoutingModule} from './home-routing.module';
import {ParentDashboardComponent} from "./components/parent-dashboard/parent-dashboard.component";
import {MainNotificationComponent} from "../../shared/components/main-notification/main-notification.component";
import {GroupComponent} from "../../shared/components/group/group.component";
import {ChildCardComponent} from "../../shared/components/child-card/child-card.component";

import {EditChildPhotoComponent} from "../../shared/components/modals/edit-child-photo/edit-child-photo.component";
import {StatisticComponent} from "../../shared/components/group/statistic/statistic.component";
import {StudyProgressBarComponent} from "../../shared/components/study-progress-bar/study-progress-bar.component";
import {PopoverComponent} from "../../shared/components/popover/popover.component";
import {StudentDashboardComponent} from "./components/student-dashboard/student-dashboard.component";

import {
    LoyaltyProgramInfoComponent
} from "../../shared/components/modals/loyalty-program-info/loyalty-program-info.component";
import {SharedModule} from "../../shared/shared.module";
import {TelegramComponent} from "../../shared/components/modals/chose-group/telegram/telegram.component";
import {ReservedComponent} from "../../shared/components/group/reserved/reserved.component";
import {PaymentComponent} from "../../shared/components/modals/payment/payment.component";
import {StudentGroupComponent} from "../../shared/components/group/student-group/student-group.component";
import {LessonMaterialsComponent} from "../../shared/components/lesson/lesson-materials/lesson-materials.component";
import {AllMaterialsComponent} from "../../shared/components/lesson/all-materials/all-materials.component";
import {PracticeComponent} from "../../shared/components/lesson/practice/practice.component";
import {StudentStatisticComponent} from "../../shared/components/group/student-statistic/student-statistic.component";
import {TestComponent} from "../../shared/components/lesson/test/test.component";
import {
    StudentNotificationComponent
} from "../../shared/components/student-notification/student-notification.component";
import {OldStudentInfoComponent} from "../../shared/components/old-student-info/old-student-info.component";
import {NewStudentInfoComponent} from "../../shared/components/new-student-info/new-student-info.component";
import {IntlTelInputNgModule} from "intl-tel-input-ng";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        HomePageRoutingModule,
        NgOptimizedImage,

        SharedModule,
        IntlTelInputNgModule,
        ReactiveFormsModule

    ],
    exports: [
        // ChatsComponent,
        // FooterComponent,
        // StudentActionsComponent,
        MainNotificationComponent,
        GroupComponent,
        // HeaderComponent,
        // ProgramItemComponent,
        LoyaltyProgramInfoComponent
    ],
    declarations: [
        HomePage,
        // ChatsComponent,
        ParentDashboardComponent,
        MainNotificationComponent,
        GroupComponent,
        ChildCardComponent,
        // StudentActionsComponent,
        EditChildPhotoComponent,
        // HeaderComponent,
        // FooterComponent,
        StatisticComponent,
        StudyProgressBarComponent,
        PopoverComponent,
        StudentDashboardComponent,
        // ProgramItemComponent,
        LoyaltyProgramInfoComponent,
        TelegramComponent,
        ReservedComponent,
        PaymentComponent,
        StudentGroupComponent,
        AllMaterialsComponent,
        LessonMaterialsComponent,
        PracticeComponent,
        StudentStatisticComponent,
        TestComponent,
        StudentNotificationComponent,
        OldStudentInfoComponent,
        NewStudentInfoComponent
    ]
})
export class HomePageModule {
}
